(() => {
  const initialize = (root) => {
    if (!root || root.dataset.syResourceDetailReady === 'true') return;
    root.dataset.syResourceDetailReady = 'true';

    const planCards = Array.from(root.querySelectorAll('[data-sy-plan]'));
    const primaryCta = root.querySelector('[data-sy-primary-cta]');
    const secondaryCta = root.querySelector('[data-sy-secondary-cta]');

    const selectPlan = (plan) => {
      if (!primaryCta) return;

      planCards.forEach((card) => {
        const selected = card.dataset.syPlan === plan;
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-checked', String(selected));
        card.tabIndex = selected ? 0 : -1;
      });

      const worldSelected = plan === 'world';
      primaryCta.classList.toggle('sy-rpd__button--primary', worldSelected);
      primaryCta.classList.toggle('sy-rpd__button--secondary', !worldSelected);
      if (secondaryCta) {
        secondaryCta.classList.toggle('sy-rpd__button--primary', !worldSelected);
        secondaryCta.classList.toggle('sy-rpd__button--secondary', worldSelected);
      }
    };

    planCards.forEach((card, index) => {
      card.addEventListener('click', () => selectPlan(card.dataset.syPlan));
      card.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + planCards.length) % planCards.length;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % planCards.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = planCards.length - 1;
        const nextCard = planCards[nextIndex];
        selectPlan(nextCard.dataset.syPlan);
        nextCard.focus();
      });
    });

    const mainMedia = root.querySelector('[data-sy-main-media]');
    const mediaThumbs = Array.from(root.querySelectorAll('[data-sy-media-thumb]'));
    mediaThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainMedia) return;
        mainMedia.src = thumb.dataset.mediaSrc;
        mainMedia.srcset = '';
        mainMedia.alt = thumb.dataset.mediaAlt || '';
        mediaThumbs.forEach((candidate) => {
          const selected = candidate === thumb;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', String(selected));
        });
      });
    });

    const resource = window.SuitYouSaved?.normalize({
      type: 'resource',
      id: root.dataset.productId,
      title: root.dataset.productTitle,
      url: root.dataset.productUrl,
      image: root.dataset.productImage,
      world: root.dataset.worldLabel,
      savedAt: Date.now(),
    });
    if (!resource) return;
    resource.url = new URL(resource.url, location.origin).href;

    // Keep one toolbar so responsive moves preserve its event handlers and focus.
    const resourceActions = root.querySelector('.sy-rpd__resource-actions');
    const mobileActions = root.querySelector('[data-sy-mobile-actions]');
    const desktopActions = root.querySelector('[data-sy-desktop-actions]');
    const mobileViewport = window.matchMedia('(max-width: 640px)');
    const placeResourceActions = () => {
      if (!root.isConnected || !resourceActions || !mobileActions || !desktopActions) return;
      if (mobileViewport.matches ? resourceActions.parentElement === mobileActions : desktopActions.nextElementSibling === resourceActions) return;
      const focusedControl = resourceActions.contains(document.activeElement) ? document.activeElement : null;
      if (mobileViewport.matches) mobileActions.append(resourceActions);
      else desktopActions.after(resourceActions);
      focusedControl?.focus({ preventScroll: true });
    };
    placeResourceActions();
    mobileViewport.addEventListener('change', placeResourceActions);

    const actionStatus = root.querySelector('[data-sy-action-status]');
    const copyButton = root.querySelector('[data-sy-copy-link]');
    const copyFallback = root.querySelector('[data-sy-copy-fallback]');

    root.querySelectorAll('[data-sy-social]').forEach((link) => {
      const channel = link.dataset.sySocial;
      if (channel === 'email') {
        link.href = `mailto:?subject=${encodeURIComponent(resource.title)}&body=${encodeURIComponent(resource.url)}`;
        return;
      }
      const destinations = {
        x: ['https://twitter.com/intent/tweet', 'url'],
        linkedin: ['https://www.linkedin.com/sharing/share-offsite/', 'url'],
        facebook: ['https://www.facebook.com/sharer/sharer.php', 'u'],
      };
      const destination = destinations[channel];
      if (!destination) return;
      const url = new URL(destination[0]);
      url.searchParams.set(destination[1], resource.url);
      if (channel === 'x') url.searchParams.set('text', resource.title);
      link.href = url.href;
    });

    if (copyButton) {
      copyButton.hidden = false;
      copyButton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(resource.url);
          copyFallback.hidden = true;
          actionStatus.textContent = 'Link copied.';
        } catch {
          copyFallback.value = resource.url;
          copyFallback.hidden = false;
          copyFallback.focus();
          copyFallback.select();
          actionStatus.textContent = 'Clipboard unavailable. Resource link ready.';
        }
      });
    }

    const cleanup = (event) => {
      if (!event.target.contains(root)) return;
      mobileViewport.removeEventListener('change', placeResourceActions);
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-sy-resource-detail]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
